import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HttpService} from "src/app/share-modul/services/common/http-service";
import {environment} from "../../../../environments/environment";
import {map, of} from "rxjs";
import {AddOrEditEmployeeModel} from "../../models/employees/add-or-edit-employee.model";
import {AssignVenuesEmployeeModel} from "../../models/employees/assign-venues-employee.model";
import {DeleteEmployeeModel} from "../../models/employees/delete-employee.model";

const EMPLOYEES_API = environment.apiURL + '/api/gmn/Employee/';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listAllEmployees() {
    let url = EMPLOYEES_API + "listallemployees";
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  getEmployeeDetails(employeeId: string) {
    let url = EMPLOYEES_API + "getemployeedetails?employeeId=" + employeeId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listAllEmployeesForVenue(venueId: string) {
    let url = EMPLOYEES_API + "listallemployeesforvenue?venueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  registerWaiter(model: AddOrEditEmployeeModel, filePicture: any) {
    let url = EMPLOYEES_API + "registerwaiter";
    const formData: FormData = new FormData();
    formData.append('FirstName', model.firstName)
    formData.append('LastName', model.lastName)
    formData.append('Email', model.email)
    formData.append('Address', model.address)
    formData.append('Phone', model.phone)
    formData.append('Pin', model.pin)
    formData.append('LanguageId', model.languageId.toString())
    formData.append('ImageFile', filePicture as string)
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  registerManager(model: AddOrEditEmployeeModel, filePicture: any) {
    let url = EMPLOYEES_API + "registermanager";
    const formData: FormData = new FormData();
    formData.append('FirstName', model.firstName)
    formData.append('LastName', model.lastName)
    formData.append('Email', model.email)
    formData.append('Address', model.address)
    formData.append('Phone', model.phone)
    formData.append('LanguageId', model.languageId.toString())
    formData.append('ImageFile', filePicture as string)
    formData.append('Pin', model.pin)
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  updateEmployee(model: AddOrEditEmployeeModel, filePicture: any) {
    let url = EMPLOYEES_API + "updateemployee";
    let formData: FormData = new FormData();
    formData.append('Id', model.id)
    formData.append('FirstName', model.firstName)
    formData.append('LastName', model.lastName)
    formData.append('Email', model.email)
    formData.append('Address', model.address)
    formData.append('Phone', model.phone)
    formData.append('EmployeeTypeId', model.venueEmployeeTypeId.toString())
    formData.append('Pin', model.pin)
    formData.append('ImageFile', filePicture as string)
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  generateNewPin() {
    let url = EMPLOYEES_API + "getnewpin";
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response.toString();
      }));
  }

  addEmployeeToVenues(model: AssignVenuesEmployeeModel) {
    let url = EMPLOYEES_API + 'addemployeetovenues';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteEmployee(model: DeleteEmployeeModel) {
    let url = EMPLOYEES_API + 'deleteemployee';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
